import {SafeHtml} from '@angular/platform-browser';

export class PageContent {
  layoutHeader1: SafeHtml;
  layoutHeader2: SafeHtml;
  layoutHeader3: SafeHtml;
  layoutHeader4: SafeHtml;
  mainPageContent1: SafeHtml;
  mainPageContent2: SafeHtml;
  layoutStep01: string;
  layoutStep02: string;
  layoutStep11: string;
  layoutStep12: string;
  layoutStep21: string;
  layoutStep22: string;
  layoutStep31: string;
  layoutStep32: string;
  layoutStep41: string;
  layoutStep42: string;
  layoutStep51: string;
  layoutStep52: string;
  firstTabSelectBrand: SafeHtml;
  firstTabSelectModel: SafeHtml;
  fourthTabTitle: SafeHtml;
  fourthTabDescription: SafeHtml;
  fourthTabCompleted: SafeHtml;
  fourthTabSection1ProductInformation: SafeHtml;
  fourthTabSection1ProposalAmount: SafeHtml;
  fourthTabSection1Text: SafeHtml;
  fourthTabSection3Title: SafeHtml;
  fourthTabSection3Text: SafeHtml;
  fourthTabHomeDeliverySelection: SafeHtml;
  fourthTabCourierDeliverySelection: SafeHtml;
  fourthTabCourierCompany: SafeHtml;
  fourthTabCourierInfoText: SafeHtml;
  fourthTabFromWhichAddressDeliver: SafeHtml;
  fourthTabChangeAddress: SafeHtml;
  fourthTabWhenWillWeDeliver: SafeHtml;
  fourthTabCantUseHomeDelivery: SafeHtml;
  layoutAnythingToRenew: SafeHtml;
  layoutApprove: SafeHtml;
  layoutNextStep: SafeHtml;
  layoutPreviousStep: SafeHtml;
  layoutProcessDescription: SafeHtml;
  layoutProcessStep1Description: SafeHtml;
  layoutProcessStep1Title: SafeHtml;
  layoutProcessStep2Description: SafeHtml;
  layoutProcessStep2Title: SafeHtml;
  layoutProcessStep3Description: SafeHtml;
  layoutProcessStep3Title: SafeHtml;
  layoutProcessTitle: SafeHtml;
  layoutProposalAmount: SafeHtml;
  layoutProposalWillBeDisplayed: SafeHtml;
  secondTabDescription: SafeHtml;
  secondTabFillMandatoryFields: SafeHtml;
  secondTabTitle: SafeHtml;
  secondTabValidationMessage: SafeHtml;
  selectionTabBuybackTooltip: SafeHtml;
  thirdTabAddress: SafeHtml;
  thirdTabAddressDescription: string;
  thirdTabCity: SafeHtml;
  thirdTabDistrict: SafeHtml;
  thirdTabTown: SafeHtml;
  thirdTabEmail: SafeHtml;
  thirdTabEmailDescription: SafeHtml;
  thirdTabEnterAddress: SafeHtml;
  thirdTabEnterEmail: SafeHtml;
  thirdTabEnterGsm: SafeHtml;
  thirdTabEnterIdentityNumber: SafeHtml;
  thirdTabEnterName: SafeHtml;
  thirdTabEnterSurname: SafeHtml;
  thirdTabEnterYearOfBirth: SafeHtml;
  thirdTabGsm: SafeHtml;
  thirdTabIdentityNumber: SafeHtml;
  thirdTabName: SafeHtml;
  thirdTabSelectCity: SafeHtml;
  thirdTabSelectDistrict: SafeHtml;
  thirdTabSelectTown: SafeHtml;
  thirdTabSurname: SafeHtml;
  thirdTabTitle: SafeHtml;
  thirdTabDescription: SafeHtml;
  thirdTabYearOfBirth: SafeHtml;
  thirdTabCashbackOrderDescription: SafeHtml;
  thirdTabCashbackOrderWarning: SafeHtml;
  thirdTabCashbackMobileWarning: string;
  thirdTabIBAN: string;
  thirdTabEnterIBAN: string;
  thirdTabIBANTooltip: string;
  thirdTabOrderNumber: string;
  thirdTabEnterOrderNumber: string;
  thirdTabOrderNumberTooltip: string;
  fourthTabSection2CourierNumber: string;
  fourthTabSection2Text: string;
  fourthTabSection2TextHomeDelivery: string;
  buybackCategories: Array<object>;
  cashbackCategories: Array<object>;
  selectionTabProposalAmount: string;
  selectionTabBuyback: string;
  selectionTabCashback: string;
  selectionTabCashbackTooltip: string;
  selectionTabCashbackDescription: string;
  layoutProcessMainTitle: string;
  layoutProcessSubtitleBuyback: string;
  layoutProcessSubtitleCashback: string;
  layoutProcessDescriptionBuyback: SafeHtml;
  layoutProcessBuyback: SafeHtml;
  layoutProcessDescriptionCashback: SafeHtml;
  layoutProcessCashback: SafeHtml;
  layoutProcessFooter: SafeHtml;
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/shared/classes/page-content.model.ts